import React from "react";

export const LinkButton: React.FC<{
  children: React.ReactNode;
  onClick(): void;
  disabled?: boolean;
  ariaLabel?: string;
}> = ({ children, onClick, disabled, ariaLabel }) => (
  <button
    type="button"
    className="cursor-pointer border-none bg-transparent p-0 text-left text-xs text-observe-primary enabled:hover:underline disabled:cursor-default disabled:text-disabled"
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel}
  >
    {children}
  </button>
);
